import i18next from 'i18next';

i18next.addResources('es_CL', 'DispatchDetails', {
  approximateTime: '{{time}} min aprox.',
  modify: 'Modificar',
  selectAddress: 'Debes seleccionar una dirección o tienda para tu orden',
  select: 'Seleccionar',
  deliveryTime: 'Tiempo de entrega'
});
